import { defaultTheme } from 'gd-design-library';

export const wrapper = {
  ...defaultTheme.wrapper,
  fullPage: {
    ...defaultTheme.wrapper.fullPage,
    zIndex: 2000
  }
};
